// npm imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../../../revvComponents";

// Components Imports
// Actions Imports
import { KanbanActions } from "../../../../actions";

// Internal Imports

// Destructuring
const { updateKanbanSearchTerm } = KanbanActions;

class KanbanHeaderSearch extends Component {
  state = {};

  render() {
    return (
      <Fragment>
        <div className="kanbanheader-search">
          <i className="kanbanheader-searchicon">
            <FontAwesomeIcon icon={["far", "search"]} />
          </i>
          <Input
            className="kanbanheader-input"
            placeholder="Search Documents"
            value={this.props.kanbanSearchTerm}
            onChange={e => this.props.updateKanbanSearchTerm(e.target.value)}
            data-test="kanbanheadersearch-input"
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { kanbanSearchTerm } = state.KanbanStore;
  return { kanbanSearchTerm };
};

const mapDispatchToProps = {
  updateKanbanSearchTerm: searchTerm => updateKanbanSearchTerm(searchTerm),
};

export default connect(mapStateToProps, mapDispatchToProps)(KanbanHeaderSearch);
